import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiRequest } from "@core/services/api/apiRequest";

type Args = {
  organizationId: number;
  mediaId: number;
};

/**
 * Delete a media upload from an organization.
 */
export function useDeleteOrganizationMedia() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ organizationId, mediaId }: Args) => {
      return await apiRequest(
        `/organization/${organizationId}/media/${mediaId}/`,
        "DELETE"
      );
    },
    onSuccess: (_data, variables) => {
      // Invalidate both logos and documents queries
      queryClient.invalidateQueries({
        queryKey: ["organization", variables.organizationId, "logos"],
      });
      queryClient.invalidateQueries({
        queryKey: ["organization", variables.organizationId, "documents"],
      });
    },
  });
}

